import { render, staticRenderFns } from "./logwood-tag.vue?vue&type=template&id=634906e4&scoped=true&"
import script from "./logwood-tag.vue?vue&type=script&lang=ts&"
export * from "./logwood-tag.vue?vue&type=script&lang=ts&"
import style0 from "./logwood-tag.vue?vue&type=style&index=0&id=634906e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634906e4",
  null
  
)

export default component.exports